import type { WorkJourneyWorkShift } from '@src/packages/workJourney/types';

const WEEKDAY_SHORT_ES: Record<number, string> = {
  1: 'Lu',
  2: 'Ma',
  3: 'Mi',
  4: 'Ju',
  5: 'Vi',
  6: 'Sa',
  7: 'Do',
};

const resolveActiveDayTimes = (
  workShift: WorkJourneyWorkShift | null | undefined,
): { startTime?: string; endTime?: string } => {
  const firstWeek = workShift?.recurrence?.weeks?.[0];
  if (!firstWeek?.days) return {};
  const active = Object.values(firstWeek.days).find(
    day => day && (day as { isActive?: boolean }).isActive !== false && day.startTime && day.endTime,
  );
  return {
    startTime: active?.startTime ?? undefined,
    endTime: active?.endTime ?? undefined,
  };
};

/** Human label for a shift select option (e.g. "Lu a Vi de 09:00 a 18:00"). */
export const formatPlanShiftLabel = (workShift: WorkJourneyWorkShift | null | undefined): string => {
  if (!workShift) return '';
  if (workShift.name && String(workShift.name).trim()) return String(workShift.name).trim();

  const days = (workShift.daysOfWeek ?? [])
    .map(day => WEEKDAY_SHORT_ES[Number(day)])
    .filter(Boolean);
  const { startTime, endTime } = resolveActiveDayTimes(workShift);

  const dayPart =
    days.length === 0
      ? ''
      : days.length === 1
        ? days[0]
        : `${days[0]} a ${days[days.length - 1]}`;
  const timePart = startTime && endTime ? `de ${startTime} a ${endTime}` : '';

  return [dayPart, timePart].filter(Boolean).join(' ') || workShift.id || '';
};
